import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import useNotify from "../../unit/useNotify";
import NoResults from "../../unit/NoResults";

const TableCellRight = styled(TableCell)({ textAlign: "right" });

const LoanOriginalSchedule = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  //loan/paymentschedule/current/appId
  const { data, error, isPending, isFetching } = useGetOne(
    "loan/paymentschedule/originalPayment",
    { id: appId }
  );
  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!data) return <CustomMessage message="No data found for this id" />;

  const originalData = data.data;

  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable
          stickyHeader
          id="table-loan-summary-original-schedule-list"
        >
          <TableHead>
            <TableRow>
              <TableCell className="hm-table-header">Payment #</TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Payment <br />
                Due Date
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Expected <br />
                Payment <br />
                Amount
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Interest <br />
                Amount
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Principal <br />
                Reduction
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Outstanding <br />
                Balance
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Equity <br />
                Built
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {originalData == undefined ||
            originalData.length == 0 ||
            originalData == null ? (
              <TableRow>
                <TableCell colSpan={8} className="no-results">
                  <NoResults />
                </TableCell>
              </TableRow>
            ) : (
              originalData.map((item: any, index: number) => (
                <TableRow
                  key={`original_${item?.iId ?? "na"}_${
                    item?.iPaymentNumber ?? "na"
                  }_${item?.dPaymentDate ?? "na"}_${index}`}
                >
                  <TableCell className="numericText">
                    {item.iPaymentNumber}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dPaymentDate)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.paymentAmount)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.interestAmount)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.principalReduction)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.outstandingBalance)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.equityBuilt)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanOriginalSchedule;
